<script lang="ts" setup>
import SessionItem from "@src/components/shared/session/SessionItem.vue";
import NoSessions from "@src/components/states/empty-states/NoSessions.vue";
import {useChatSessionStore} from "@src/stores/chatSession";

const props = defineProps([
    'sessions'
]);
const sessionStore = useChatSessionStore();
</script>

<template>
    <div class="h-full overflow-y-auto scrollbar-thin">

        <template v-if="props.sessions.length > 0">
            <SessionItem v-for="session in props.sessions"
                         :id="session.id"
                         :key="session.id"
                         :avatar="session.costumer?.profile_picture || 'https://sistema.dchat.com.br/images/avatar.jpg'"
                         :costumer-id="session.costumer?.id"
                         :department="session.department?.name"
                         :has-new-message="session.has_new_messages"
                         :isExpired="session.is_expired"
                         :isFixed="session.is_fixed"
                         :isSpin="session.is_spin"
                         :last-message="session.last_message ?? null"
                         :last-message-date="session.last_message?.created_at"
                         :name="session.costumer?.name || 'Cliente'"
                         :status="session.status"
                         :type="session.channel?.type || 'whatsapp'"
                         @click="sessionStore.selectSession(session)"
            />
        </template>

        <NoSessions v-else/>

    </div>
</template>

<style scoped>

</style>